import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
  
 USD : [
    "USD 50", "Revenue", "Inventory"],
};


const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);


  return (
<div className="flex flex-col w-full relative ">
  {/* Button + Icon Container */}
  <div className='flex  md:space-x-12 space-x-10 items-center'>
    {/* Left Side: USD and 25Kg */}
    <div className='flex'>
      <button
        className="xl:w-[290px] lg:w-[200px]  lg:text-[24px] md:text-[15px]  md:w-[160px]  w-[80px] h-[20px] md:h-[74px] bg-[#2E453D] text-white font-normal flex justify-center items-center px-1 rounded-l-[5px]"
      >
        <span className="xl:text-[36px] lg:text-[28px] md:text-[16px]  md:px-4 text-[6px] md:mt-0 mt-[2px]">25Kg</span>
      </button>
      
      {/* Dropdown Button */}
      <div className="flex relative z-20 w-fit">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="xl:w-[290px] lg:w-[200px] lg:text-[24px] md:text-[16px] md:w-[160px]   w-[80px] h-[20px] md:h-[74px] bg-[#152C24] text-white font-bold flex justify-between items-center md:px-6 px-3 rounded-r-[5px]"
        >
          <span className="xl:text-[36px] lg:text-[28px] md:text-[16px]   md:px-4 text-[6px] md:mt-0 mt-[2px]">{selected}</span>
          <div
            className="w-[20px] h-[15px] md:h-[47px] md:w-[40px] text-white flex justify-center items-center rounded-[5px]  z-30 cursor-pointer"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
              alt="expand"
              className="w-1 h-1 md:w-5 md:h-5"
            />
          </div>
          {/* Dropdown List */}
          <AnimatePresence>
            {isOpen && (
              <motion.ul
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className="absolute top-full mt-1 left-0 z-50 md:w-[280px] w-[100px] bg-white/90 rounded-lg shadow-lg"
              >
                {items.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setSelected(item);
                      setIsOpen(false);
                    }}
                    className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
                  >
                    <span className="text-black">{item}</span>
                  </li>
                ))}
              </motion.ul>
            )}
          </AnimatePresence>
        </button>
      </div>
    </div>

    {/* Right Side: Register as a Farmer Button */}
    <div>
      <button className='md:text-[36px] font-bold text-[6px] rounded-[5px] md:w-[300px] lg:w-[240px] xl:w-[566px] w-[150px] md:h-[74px] h-[20px] md:p-3 p-1 text-center justify-center items-center flex bg-[#152C24] text-white'>
      Buy
      </button>
    </div>
  </div>
</div>



  
  );
};
const ResourcesPage1 = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(false); // State to control video visibility
  const [weight, setWeight] = useState('25Kg');
  const [price, setPrice] = useState('USD 50');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('USD 50');

  const options = ['USD 50', 'USD 100', 'USD 150'];
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.relative')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [selected, setSelected] = useState('USD 50');
  const dropdownRef = useRef(null);


  const toggleDropdown = () => setIsOpen(!isOpen);

 

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handlePlayClick = () => {
    setShowVideo(true); // Show video when play icon is clicked
  };

  const closeVideo = () => {
    setShowVideo(false); // Close video and return to image
  };

  return (
    <div className='bg-white'>
      <div className='px-4 md:px-24 pt-3'>
        <h1 className="text-[10px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">Resources</h1>
        <h1 className="text-[10px] md:text-[32px] font-bold mb-3 md:mb-8 text-black">Farming Inputs</h1>

        <div className="relative w-full overflow-hidden rounded-lg bg-white">
          <div className="relative w-full rounded-lg">
            {isLoading && !showVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[green] border-solid"></div>
              </div>
            )}

            {/* Image fallback, shown when video is not playing */}

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745518734/image_29_pyl9em.png"
              alt="Securing Agriculture in Namibia"
              className={`w-full md:h-[622px] object-cover rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
              onLoad={() => setIsLoading(false)}
            />




          </div>
        </div>

        {/* Content Section */}
        <div className='px-1'>
          <div className="md:mt-5 mt-2 w-full">
            <div className="flex items-center justify-between text-[13px] md:text-[30px] font-normal text-black">
              <div className='flex items-center md:space-x-28 space-x-8'>
                <h3 className="text-black font-normal text-[10px] md:text-[32px]">Maize</h3>

                <p className='font-bold  text-[10px] md:text-[32px]' >FDP Agro</p>
              </div>
              <div className="flex items-center md:gap-12 gap-2  text-black">
                <p className=' text-[10px] md:text-[32px]'>Farmnet</p>

                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745522400/image_1618_ti4k2t.png"
                  alt="Clock"
                  className="h-3 w-3 md:h-8 md:w-8"
                />
              </div>
            </div>
            <h3 className="text-black font-normal text-[10px] md:text-[32px]">Product by Sponsor</h3>

          </div>

          {/* Main Text Section */}
          <h3 className="text-black font-bold text-[8px] md:text-[32px] mt-3 md:mt-5">
            Features and benefits
          </h3>

          {/* Main Text Section */}
          <div className="md:mt-1 mt-2 md:space-y-10 space-y-5">

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>1. Drought Resistance</strong><br />
              Feature: The new seed variety is designed to withstand prolonged periods of drought with reduced water requirements. Benefit: This feature ensures farmers can maintain crop yields even in regions experiencing water scarcity, reducing the risk of crop failure and supporting food security in arid climates.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>2. Higher Yield Potential</strong><br />
              Feature: The new seed variety is genetically enhanced to produce higher crop yields per hectare. Benefit: Farmers can significantly increase their productivity without needing to expand their land area, leading to greater profits and more efficient land use.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>3. Pest and Disease Resistance</strong><br />
              Feature: The seed variety has built-in resistance to common pests and diseases. Benefit: This reduces the need for chemical pesticides, lowering production costs, minimizing environmental impact, and enhancing the sustainability of farming practices.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>4. Faster Maturation</strong><br />
              Feature: The seed variety has a shorter growth cycle, allowing it to mature faster than traditional varieties. Benefit: Farmers can harvest crops earlier, enabling multiple harvests per year and improving cash flow. This also helps in responding more quickly to market demand or seasonal changes.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>5. Improved Nutrient Profile</strong><br />
              Feature: The new seed variety is bred to produce crops with enhanced nutritional content (e.g., higher protein, vitamins, or minerals). Benefit: This can lead to healthier food for consumers and can be a selling point in markets where nutrition is a key focus. It also offers an opportunity for farmers to tap into niche markets like fortified or biofortified foods.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>6. Environmental Adaptability</strong><br />
              Feature: The seed variety is designed to thrive in diverse soil types and environmental conditions. Benefit: Farmers in different regions can cultivate the crop successfully, improving resilience to climate variability and reducing reliance on specific growing conditions.
            </p>

            <p className="text-[10px] md:text-[32px] text-black font-normal">
              <strong>7. Better Quality Crops</strong><br />
              Feature: The seed variety produces crops with superior size, color, taste, or other quality traits. Benefit: The improved quality can lead to higher market prices and better customer satisfaction, enhancing farmers' reputation and demand for their products.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>8. Improved Soil Health</strong><br />
              Feature: Certain new seed varieties have roots that help improve soil structure and fertility. Benefit: This enhances long-term soil health, promoting sustainable farming practices by reducing the need for chemical fertilizers and improving the ability of soil to retain moisture and nutrients.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>9. Resistance to Climate Stress</strong><br />
              Feature: The seed variety is designed to better cope with extreme temperatures, either heat or cold. Benefit: Farmers can grow crops in regions or under conditions previously unsuitable for traditional varieties, expanding their growing area and mitigating the risks of climate change.
            </p>

            <p className="text-[8px] md:text-[32px] text-black font-normal">
              <strong>10. Reduced Post-Harvest Losses</strong><br />
              Feature: The new seed variety has a longer shelf life and better resistance to spoilage during storage. Benefit: This reduces post-harvest losses, allowing farmers to store and sell their produce over a longer period, increasing overall profitability.
            </p>

            <div className='md:h-10 h-5'></div>
          </div>
        
    <div className="flex md:gap-2 gap-[1px]   ">
    

    {Object.keys(dropdownItems).map((type) => {
      const customLabels = {
        Crop: "Crop Report",
        Livestock: "Livestock Report",
        Type: "Type of Report",
      };

      const displayLabel = customLabels[type] || type;

      return (
        <div key={type} className="w-full sm:w-auto">
          <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
        </div>
      );
    })}
  </div>
  <div className='md:h-72 h-4'></div>

        </div>
      </div>

   
    </div>
  );
};

export default ResourcesPage1;
